"use strict";

const AppApi = class AppApi {

	_defaultTimeout = 30000;

	constructor(parameters) {
		this._sessid = '';

		this._params = parameters || {};

		if (this._params.sessid) {
			this._sessid = this._params.sessid;
		}
	}

	/**
	 * @param url
	 * @param method
	 * @param responseType
	 * @param data
	 * @param showToast
	 * @param timeout
	 * @param addToCache
	 * @param cacheType
	 * @returns {Promise<unknown | boolean>}
	 */
	request(url, method = 'GET', responseType = 'text',
	        data = {},
	        showToast = false,
	        timeout = this._defaultTimeout,
	        addToCache = false,
	        cacheType = 'runtime'
	) {
		let _component = this;

		//Добавление запроса в кэш SW (auth с капчей не кешируем)
		let skipSwCache = /(?:^|\/)(?:api\/)?modal\/auth\/?/.test(url);
		if (addToCache && !skipSwCache && 'serviceWorker' in navigator && navigator.serviceWorker.controller) {
			navigator.serviceWorker.controller.postMessage({addToCache: url, cacheType: cacheType});
		}

		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest();

			if (typeof responseType === 'string' && responseType) xhr.responseType = responseType;

			if (data && typeof data === 'object' && Object.keys(data).length && method === 'GET') {
				let params = new URLSearchParams(data);
				url = url + '?' + params.toString();
			}

			xhr.timeout = timeout;
			xhr.open(method, url);

			if (url.indexOf('http://') !== 0 && url.indexOf('https://') !== 0) {
				xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
			}

			if (data && data.sessid) {
				_component._sessid = data.sessid;
			} else if (url.indexOf('http://') !== 0 && url.indexOf('https://') !== 0) {
				xhr.setRequestHeader('X-Bitrix-Csrf-Token', _component._sessid);
			}

			xhr.onload = () => {
				if (xhr.status >= 200 && xhr.status < 300 && xhr.response) resolve(xhr.response);
				else reject({status: xhr.status, response: xhr.response});
			};

			xhr.onerror = () => reject({status: xhr.status, response: xhr.response});

			if (method !== 'GET') {
				if (data && typeof data === 'object' && data instanceof FormData) {
					xhr.send(data);
				} else if (data && typeof data === 'object' && Object.keys(data).length) {
					let formData = new FormData();
					for (let key in data) formData.append(key, data[key]);
					xhr.send(formData);
				} else {
					xhr.send();
				}
			} else {
				xhr.send();
			}
		}).then((response) => {

			return response;
		}).catch((err) => {

			console.error(err);
			let errorMessage = (window.App && App.getMessage)
				? App.getMessage('requestError')
				: 'Произошла ошибка при выполнении запроса';
			if (err.response && err.response.errors && Array.isArray(err.response.errors)) {
				errorMessage = err.response.errors.join('<br/>');
			} else if (err.response && typeof err.response === 'string') {
				errorMessage = err.response;
			}

			if (!App || !App.isInitialized()) {
				document.addEventListener('AppInit', function (e) {
					e.detail.showToast(errorMessage, 'error');
				});
			} else {
				App.showToast(errorMessage, 'error');
			}

			return false;
		});
	}

	/**
	 * @param url
	 * @param method
	 * @param data
	 * @param addToCache
	 * @param cacheType
	 * @returns {Promise<*>}
	 */
	apiRequest(url, method = 'GET', data, addToCache, cacheType) {
		return this.getJSON(('/api/' + url), method, data, true, undefined, addToCache, cacheType);
	}

	/**
	 * @param url
	 * @param method
	 * @param data
	 * @param showToast
	 * @param timeout
	 * @param addToCache
	 * @param cacheType
	 * @returns {Promise<*>}
	 */
	getJSON(url, method = 'GET', data, showToast, timeout, addToCache, cacheType) {
		return this.request(url, method, 'json', data, showToast, timeout, addToCache, cacheType);
	}

	/**
	 * @param data
	 * @param method
	 * @returns {Promise<*>}
	 */
	basket(data, method = 'GET') {
		return this.apiRequest('basket/', method, data);
	}

	/**
	 * @param data
	 * @param method
	 * @returns {Promise<*>}
	 */
	order(data, method = 'GET') {
		return this.apiRequest('order/', method, data);
	}

	/**
	 * @param data
	 * @param method
	 * @returns {Promise<*>}
	 */
	wishlist(data, method = 'POST') {
		return this.apiRequest('product/wishlist.php', method, data);
	};

	/**
	 * @param data
	 * @param method
	 * @returns {Promise<*>}
	 */
	delivery(data, method = 'POST') {
		return this.apiRequest('product/delivery.php', method, data);
	};

	/**
	 * @param data
	 * @param method
	 * @returns {Promise<*>}
	 */
	inserts(data, method = 'POST') {
		return this.apiRequest('product/inserts.php', method, data);
	};

	/**
	 * @returns {Promise<*>}
	 */
	getHeaderBasket() {
		return this.apiRequest('basket/header.php', 'POST');
	};

	/**
	 * @returns {Promise<*>}
	 */
	getFullBasket() {
		return this.apiRequest('basket/full.php', 'POST');
	};

	/**
	 * @param modalName
	 * @param type
	 * @param params
	 * @param json
	 * @param addToCache
	 * @param cacheType
	 * @returns {Promise<*>|Promise<*>}
	 */
	loadAjaxModal(modalName, type = 'json', params = {}, json = true, addToCache = false, cacheType = 'runtime') {
		switch (type) {
			case 'json':
				return this.apiRequest('modal/' + modalName + '/', 'POST', {params: params}, addToCache, cacheType);
			default:
				return this.request(modalName, 'POST', 'text', {params: params}, false, this._defaultTimeout, addToCache, cacheType);
		}
	};

	/**
	 * @param path
	 * @param params
	 * @returns {Promise<*>}
	 */
	loadMore(path, params = {}) {
		return this.apiRequest(path, 'POST', {params: params});
	};
};

export {AppApi};